import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  jwtToken: null,
  loading: false,
  impersonatedUser: null,
  user: {},
  _user: {},
  navigationRoutes: [],
  modalLockdown: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  setJwtToken(state, token)
  {
    state.jwtToken = token
  },
  setImpersonatedUser(state, user)
  {
    if (user) {
      state._user = state.user
      state.user = user
      state.impersonatedUser = user.email
    } else {
      state.user = state._user
      state.impersonatedUser = null
    }
  },
  setUser(state, user) {
    state.user = user
  },
  startLoading(state) {
    state.loading = true
  },
  stopLoading(state)  {
    state.loading = false
  },
  setAgencyTermsOfUse(state, terms) {
    state.user.agency.terms = terms
  },
  setNavigationRoutes(state, routes) {
    state.navigationRoutes = routes
  },
  setModalLockdown(state, locked) {
    state.modalLockdown = locked
  }
}

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state,
  mutations,
  plugins: [vuexLocal.plugin]
})
